import React from 'react'
import "./Campnou.css"
import Navbar from "../navbar/Navbar"
import Header from "../header/Header"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import { faCircleArrowLeft, faCircleArrowRight, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";
import { Map } from "../Map/Map"
import Modal from 'react-modal'
import {AiOutlineCloseCircle} from 'react-icons/ai'
import { loadStripe } from '@stripe/stripe-js'
import { Elements, CardElement, useStripe, useElements} from '@stripe/react-stripe-js'
import axios from 'axios'
import Swal from 'sweetalert2'



const stripePromise = loadStripe('pk_test_51NG6XgB439p1m1xwSpPezHZwMU1w00Eg2K7aK3qf92B9RoXHZcgIfmJfd8DDpjTOYNV7wfDkVGJkYAEN3zbQITU600cyjv6lC1')

const mostrarAlerta=()=>{
    Swal.fire({
            position: 'top-center',
            icon: 'success',
            title: 'Compra exitosa',
            showConfirmButton: false,
            timer: 2000,
    })
    }


const CheckoutForm = () =>{

    const stripe = useStripe();
    const elements = useElements();

    const handleSumbit = async (e) =>{
        e.preventDefault();
    
        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement)
        })

        if (!error){
            const { id } = paymentMethod;
            
            const { data }= await axios.post('http://localhost:5000/api/checkout',{
                id,
                amount: 90.000
            })
            console.log(data);

            elements.getElement(CardElement).clear();
    }
    }


    return <form onSubmit={handleSumbit} className='card'>
    <img src="https://res.cloudinary.com/dptohgiiu/image/upload/v1686344023/WhatsApp_Image_2023-06-09_at_3.53.21_PM_wngqvl.jpg" alt="" className='imglog' />
    <div className='Compra'>
        <h3 className='rsu'>Resumen de tu reserva</h3>
    <h3 className='con'>Concepto</h3>
    <p className='Pr'>Reserva de CampNou 1 hora cancha futbol 8 hora 3:00 Pm</p>
    <hr />
    <h3 className='val'>Valor Reserva</h3>
    <p className='pre'>120.000</p>
    <img  className='paycan' src="https://res.cloudinary.com/dptohgiiu/image/upload/v1686079029/35236561_384910932005016_7951147314406490112_n_hcavr0.jpg" alt="" />
    <p className='pcananchabuy'>Cancha futbol 8</p>
    <h3 className='text-center'>Total a pagar: 95.000</h3>
    <CardElement className='tarjeta'/>  
    <button onClick={()=>mostrarAlerta()} className='buycan' disabled={!stripe}>
        Reservar
    </button>
    </div>
</form>
}


export const Campnou = () => {
    const [slideNumber, setSlideNumber, newSlideNumber] = useState (0);
    const [open, setOpen] = useState (false);
    const photos = [
    {
        src: "https://res.cloudinary.com/dptohgiiu/image/upload/v1686630009/CAMPNOU1_r05pam.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686630009/CAMPNOU3_fnjboc.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686630009/CAMPNOU2_f3mirm.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686630009/CAMPNOU4_hhnsnt.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686676536/campnou7_vgp9qs.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686630169/CAMPNOU6_sxjymp.jpg"
    }, 

    ];

    const handleOpen = (i) =>{
        setSlideNumber(i);
        setOpen(true);
    };
    const handleMove = (direction)=>{
        
        let  newSlideNumber;

        if(direction==="l"){
            newSlideNumber = slideNumber === 0 ? 5 : slideNumber-1;
        } else{
            newSlideNumber = slideNumber === 5 ? 0 : slideNumber +1;
        }
        setSlideNumber(newSlideNumber)
    };

    const [modalIsOpen3, setIsOpen3] = React.useState(false);

    function openModal3() {
        setIsOpen3(true);
    }

    function closeModal3() {
        setIsOpen3(false);
    }

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    return (
        <div>
            <Navbar/>
            <Header type="list"/>
            <div className="canchaContainer">
                {open && <div className="slider">
                    <FontAwesomeIcon icon={faCircleXmark} className="close" onClick={()=>setOpen(false)}/>
                    <FontAwesomeIcon icon={faCircleArrowLeft} className="arrow" onClick={()=>handleMove("l")}/>
                    <div className="sliderWrapper">
                        <img src={photos[slideNumber].src}  alt="" className="sliderImg" />
                    </div>
                    <FontAwesomeIcon icon={faCircleArrowRight}className="arrow" onClick={()=>handleMove("r")}/>
                </div>}
                <div className="canchaWrapper">
                    <h1 className="canchaTitle">Campnou</h1>
                    {/* <button className="reservaAhora">Reservar ahora</button> */}
                    <div className="canchaAddress">
                        <FontAwesomeIcon icon={faLocationDot}/>
                        <span>...</span>
                    </div>
                    <span className="canchaDistance">
                        Excelente localización - 50m del centro
                    </span>
                    <span className="canchaPriceHighlight">
                        si alquila por más de 1 hora en esta cancha se le dara un descuento de un 2% en el proximo alquiler
                    </span>
                    <div className="canchaImages">
                        {photos.map((photo,i)=>(
                            <div className="canchaImgWrapper">
                                <img onClick={()=>handleOpen(i)}src={photo.src} alt="" className="canchaImg" />
                            </div>
                        ))}
                    </div>
                    <div className="canchaDetails">
                        <div className="canchaDetailsTexts">
                            <h1 className="canchaTitle">
                                Campnou
                            </h1>
                            <p className="canchaDesc">
                            Canchas Sintéticas Campnou, Armenia, Quindío, Colombia está ubicado en Armenia, Quindío, Colombia, cerca de este lugar son: Gimnasio SuperGym (630 m), Centro Deportivo Mormones La Castellana (730 m), Edificio Castellana 9 A N 58 (976 m), Pulso Box armenia (1 km), GIMNASIO EQUILIBRIUM FITNESS (1 km).

                            </p>
                            </div>
                            <div className="canchaDetailsPrice">
                                <h1>Perfecta para jugar!</h1>
                                <span>
                                Cancha con • luces • tienda • gradas de puestos
                                </span>
                                <h2>
                                    $95.000 (1 hora)
                                </h2>
                                <button className="btnrese" onClick={openModal}>Reservar</button>
                            </div>
                            <div className="canchaDetailsPrice">
                                <h1>Perfecta para jugar!</h1>
                                <span>
                                Cancha con • luces • tienda • gradas de puestos
                                </span>
                                <h2>
                                    $100.000 (1 hora)
                                </h2>
                                <button className="btnrese" onClick={openModal3}>Reservar</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                    <Map/>

                    <Modal isOpen={modalIsOpen3}
                        onRequestClose={closeModal3}>
                            <button className='pointer' onClick={closeModal3}>
                        <AiOutlineCloseCircle></AiOutlineCloseCircle>
                        </button>
                            
                        <Elements stripe={stripePromise}>
                        <CheckoutForm/>
                        </Elements>
                        
                    </Modal>

                    <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={closeModal}
                    ><button className='pointer' onClick={closeModal}>
                        <AiOutlineCloseCircle></AiOutlineCloseCircle>
                        </button>
                        
                        <Elements stripe={stripePromise}>
                        <CheckoutForm/>
                        </Elements>
                        
                    
                        </Modal>
            </div>
    )
}

